import React from 'react';
import { Alert, Text, Input, Button } from '../ui';
import { validateURL } from '../../utils/helpers';

const WebsiteForm = ({ error, loading, websiteUrlInput, setWebsiteUrlInput, onSubmit }) => {
  return (
    <div className='w-full h-[calc(100vh-8rem)] flex items-center justify-center p-2 sm:p-4 relative'>
      <main className='w-full max-w-xl '>
        <div className='p-4 sm:p-8 md:p-12 lg:p-16 shadow-xl rounded-xl border card-gradient'>
          {/* Header */}
          <div className='text-center mb-4 sm:mb-6 md:mb-8'>
            <Text variant='heading' className='text-xl md:text-3xl'>
              Welcome! Let's get you set up.
            </Text>
          </div>

          {/* Instruction */}
          <Text
            variant='body'
            className='text-center mb-4 md:mb-4 text-xs sm:text-sm md:text-base'
            style={{ color: 'var(--text-muted)' }}
          >
            Enter your website URL to begin
          </Text>

          {/* Error Alert */}
          {error && (
            <div className='mb-4 sm:mb-6 md:mb-8'>
              <Alert variant='error'>{error}</Alert>
            </div>
          )}

          {/* Form */}
          <form onSubmit={onSubmit}>
            <div className='space-y-3 sm:space-y-4 md:space-y-6'>
              {/* Website URL Input */}
              <div>
                <Input
                  id='website-url'
                  name='website-url'
                  type='url'
                  value={websiteUrlInput}
                  onChange={(e) => {
                    const { isValid, url } = validateURL(e.target.value);
                    if (isValid) {
                      setWebsiteUrlInput(url);
                    } else {
                      setWebsiteUrlInput(e.target.value);
                    }
                  }}
                  placeholder='https://yourwebsite.com'
                  disabled={loading}
                  centered
                  required
                  className='text-xs sm:text-sm md:text-base'
                  variant='ghost'
                />
              </div>

              {/* Submit Button */}
              <div>
                <Button
                  type='submit'
                  disabled={loading}
                  variant='primary'
                  className='w-full py-2 sm:py-2.5 md:py-3.5 text-xs sm:text-sm md:text-base'
                  loading={loading}
                >
                  {loading ? 'Starting Setup...' : 'Start Setup'}
                </Button>
              </div>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
};

export default WebsiteForm;
